import React from 'react';
import { Wrapper } from './DiversityStats.styles';
import ChartsWrapper from './ChartsWrapper';

const DiversityStats = () => {
	return (
		<Wrapper>
			<ChartsWrapper />
		</Wrapper>
	);
};

export default DiversityStats;
